import { Spinner } from "../Spinner";

export const PageLoader = () => (
  <div className="flex items-center justify-center min-h-[60vh] w-full">
    <Spinner width={28} height={28} />
  </div>
);
